module.exports = __webpack_public_path__ + "static/hoodedknittedheart-6ca77ed8ad2bba58d6d91ba0b1bc892b.jpeg";